import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { ShortBody } from 'components/Typography';

export const StyledGrid = styled(Grid)`
width: 552px; !important;
`;
export const StyledGridLeft = styled(({ reverse, ...otherProps }) => (
  <Grid {...otherProps} />
))`
  margin-right: ${(props) => (props.reverse ? '4px' : '0px')} !important;
  margin-left: ${(props) => (props.reverse ? '0px' : '4px')} !important;
`;

export const StyledBodyText = styled(ShortBody)`
  white-space: pre-line;
  color: #162952 !important;
  font-size: 14px !important;
  line-height: 24px !important;
  max-height: 500px !important;
  margin-top: 2px !important;
  margin-bottom: 10px !important;
`;
